import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { LicenseInfo } from '../../../../store/LicenseInfo';
import { selectLicense } from '../selectors';

export const useLicense = () => useSelector(selectLicense);

export function useLicenseInfo() {
  const licenseState = useLicense();
  return useMemo(() => new LicenseInfo(licenseState), [licenseState]);
}
